import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import ScrollableRow from './ScrollableRow';
import RecordingCard from './RecordingCard';
import { cssClampValue } from '../utils/common';

const Wrapper = styled.div``;

const Title = styled.h2`
  margin: 0 0 ${cssClampValue(10, 40)};
  font-family: var(--earth-fm--font-family--jakarta);
  font-size: ${cssClampValue(18, 24)};
`;

interface Props {
  title?: string;
  isDefaultContentVisible?: boolean;
}

export default function PopularRecordings({
  title = 'Popular recordings',
  isDefaultContentVisible = false,
}: Props) {
  const data = useStaticQuery<Queries.PopularRecordingsQuery>(graphql`
    query PopularRecordings {
      allWpRecording(sort: { popularity: DESC }, limit: 12) {
        nodes {
          ...RecordingCardData
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Title>{title}</Title>
      <ScrollableRow title={title} isDefaultContentVisible={isDefaultContentVisible}>
        {data.allWpRecording.nodes.map((recording) => (
          <RecordingCard key={recording.id} data={recording} />
        ))}
      </ScrollableRow>
    </Wrapper>
  );
}
